import { render, staticRenderFns } from "./chat-media-upload-preview.vue?vue&type=template&id=2ec8a7a8&scoped=true&"
import script from "./chat-media-upload-preview.vue?vue&type=script&lang=js&"
export * from "./chat-media-upload-preview.vue?vue&type=script&lang=js&"
import style0 from "./chat-media-upload-preview.vue?vue&type=style&index=0&id=2ec8a7a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8a7a8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec8a7a8')) {
      api.createRecord('2ec8a7a8', component.options)
    } else {
      api.reload('2ec8a7a8', component.options)
    }
    module.hot.accept("./chat-media-upload-preview.vue?vue&type=template&id=2ec8a7a8&scoped=true&", function () {
      api.rerender('2ec8a7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-media-upload-preview/chat-media-upload-preview.vue"
export default component.exports